package com.appcreator.compose.actions

import coil3.PlatformContext
import kotlinx.browser.window

actual fun copyTextToClipboard(text: String, context: PlatformContext) {
    window.navigator.clipboard.writeText(text)
}